import { Box, Button, Grid } from '@mui/material'
import { CarrierVisitScheduleTimings } from '@planning/components/CarrierVisitScheduleTimings'
import {
  VesselVisitBerthAndTimingFormStore,
  VisitType,
} from '@planning/pages/VesselVisit/Stores/VesselVisitBerthAndTimingFormStore'
import { useTranslate } from '@tolgee/react'
import { observer } from 'mobx-react-lite'

export const VisitTypeSelector = observer(
  ({ store }: { store: VesselVisitBerthAndTimingFormStore }) => {
    // TODO: use translations
    const { t } = useTranslate()

    const options: VisitType[] = ['Single visit', 'Repeating visit']
    return (
      <>
        <Grid size={{ xs: 12 }}>
          <Box display='flex' gap={1}>
            {options.map(option => (
              <Button
                key={option}
                size='small'
                variant='contained'
                color={store.visitType.value === option ? 'secondary' : 'inherit'}
                onClick={() => {
                  store.visitType.setValue(option)

                  store.schedule.showTimingOptions.setValue(option === 'Repeating visit' ? 1 : 0)
                }}
              >
                {option}
              </Button>
            ))}
          </Box>
        </Grid>

        {store.visitType.value === 'Repeating visit' && (
          <Grid size={{ xs: 12 }} mb={'2rem'}>
            <CarrierVisitScheduleTimings
              schedule={store.schedule.data}
              onChange={val => store.schedule.setData(val)}
            />
          </Grid>
        )}
      </>
    )
  },
)
